module.exports = __webpack_public_path__ + "img/12n.6c1c9712.png";